module.exports = __webpack_public_path__ + "img/export-icon.465b349f.svg";